import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { MODULE_COLORS } from '@cubemeet/core/theme';

type Option = { id: string; labelKey: string; descKey?: string; icon?: string };

const VisibilityPicker: React.FC<{ value: string; onChange: (v: string) => void; options: Option[]; t: (key: string) => string }> = ({ value, onChange, options, t }) => {
  return (
    <View style={{ gap: 12 }}>
      {options.map((o) => {
        const active = value === o.id;
        return (
          <TouchableOpacity key={o.id} style={[styles.item, active && styles.itemActive]} onPress={() => onChange(o.id)}>
            <Icon name={active ? 'radio-button-checked' : 'radio-button-unchecked'} size={20} color={MODULE_COLORS.travel} />
            <View style={styles.texts}>
              <Text style={[styles.title, active && styles.titleActive]}>{t(o.labelKey)}</Text>
              {o.descKey && <Text style={[styles.subtitle, active && styles.subtitleActive]}>{t(o.descKey)}</Text>}
            </View>
            {o.icon && <Icon name={o.icon} size={22} color={MODULE_COLORS.travel} />}
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  item: { flexDirection: 'row', alignItems: 'center', padding: 12, borderRadius: 12, borderWidth: 1, borderColor: '#E5E7EB', backgroundColor: '#fff' },
  itemActive: { borderColor: MODULE_COLORS.travel, backgroundColor: '#FFF7ED' },
  texts: { flex: 1, marginLeft: 12 },
  title: { fontSize: 15, color: '#374151' },
  titleActive: { color: MODULE_COLORS.travel, fontWeight: '700' },
  subtitle: { fontSize: 13, color: '#6B7280', marginTop: 4 },
  subtitleActive: { color: '#6B7280' },
});

export default VisibilityPicker;
